
    /* Valeur fermée attendue par n8n/Klaviyo pour properties[poids_chien] : Petit / Moyen / Grand */
    function tierToPoidsChien(tier) {
      var map = { petit: 'Petit', moyen: 'Moyen', grand: 'Grand' };
      return map[tier] || '';
    }

    (() => {
      const galleries = document.querySelectorAll('.jl-gallery-strip[data-gallery]');
      galleries.forEach((gallery) => {
        const section = gallery.closest('.jl-formula-shell');
        if (!section) return;
        const mainImage = section.querySelector('.jl-gallery-main img');
        const mainFrame = section.querySelector('.jl-gallery-main');
        const track = gallery.querySelector('.jl-gallery-track');
        const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
        const mainPrev = section.querySelector('[data-gallery-main-arrow="prev"]');
        const mainNext = section.querySelector('[data-gallery-main-arrow="next"]');
        if (!mainImage || !track || !thumbs.length) return;

        let activeIndex = thumbs.findIndex((thumb) => thumb.classList.contains('is-active'));
        let startIndex = 0;
        let touchStartX = 0;
        let touchEndX = 0;
        let touchStartY = 0;
        let touchEndY = 0;
        let cachedStep = null;
        if (activeIndex < 0) activeIndex = 0;

        const visibleCount = () => {
          if (window.innerWidth < 750) return 4;
          if (window.innerWidth < 1100) return 5;
          return 6;
        };

        const refresh = (focusActive = false) => {
          thumbs.forEach((thumb, index) => {
            thumb.classList.toggle('is-active', index === activeIndex);
          });
          const activeThumb = thumbs[activeIndex];
          if (activeThumb) {
            const isVideo = activeThumb.dataset.mediaType === 'video';
            let mainVideo = mainFrame.querySelector('.jl-gallery-main-video');
            if (isVideo) {
              /* Vidéo : 480p sur mobile, 720p sinon */
              const src = (window.innerWidth < 750 && activeThumb.dataset.videoSd)
                ? activeThumb.dataset.videoSd
                : (activeThumb.dataset.videoHd || activeThumb.dataset.videoSd);
              if (!mainVideo) {
                mainVideo = document.createElement('video');
                mainVideo.className = 'jl-gallery-main-video';
                mainVideo.controls = true;
                mainVideo.playsInline = true;
                mainVideo.muted = true;
                mainVideo.loop = true;
                mainVideo.preload = 'metadata';
                mainFrame.insertBefore(mainVideo, mainImage.nextSibling);
              }
              if (mainVideo.getAttribute('src') !== src) {
                mainVideo.src = src;
                mainVideo.poster = activeThumb.dataset.poster || '';
              }
              mainImage.style.display = 'none';
              mainVideo.style.display = 'block';
              mainVideo.play().catch(() => {});
            } else {
              if (mainVideo) {
                mainVideo.pause();
                mainVideo.style.display = 'none';
              }
              mainImage.style.display = '';
              const nextSrc = activeThumb.dataset.src;
              const nextAlt = activeThumb.dataset.alt || mainImage.alt;
              if (mainImage.src !== nextSrc) {
                mainFrame.classList.add('is-transitioning');
                window.setTimeout(() => {
                  /* Retirer srcset/sizes sinon le navigateur ignore le nouveau src (galerie bloquée sur la 1re image) */
                  mainImage.removeAttribute('srcset');
                  mainImage.removeAttribute('sizes');
                  mainImage.src = nextSrc;
                  mainImage.alt = nextAlt;
                }, 50);
              } else {
                mainImage.alt = nextAlt;
              }
            }
          }

          const maxStart = Math.max(0, thumbs.length - visibleCount());
          startIndex = Math.max(0, Math.min(startIndex, maxStart));
          if (focusActive) {
            if (activeIndex < startIndex) startIndex = activeIndex;
            if (activeIndex >= startIndex + visibleCount()) startIndex = activeIndex - visibleCount() + 1;
          }

          if (window.innerWidth < 750) {
            /* Mobile : le strip est en scroll natif (CSS overflow-x).
               IMPORTANT : ne scroller QUE le conteneur horizontal, jamais la page.
               (scrollIntoView remontait toute la page au moindre resize — la barre
               d'adresse mobile qui se rétracte déclenche resize → jump en haut) */
            const activeThumbEl = thumbs[activeIndex];
            const wrap = track.parentElement;
            if (activeThumbEl && focusActive && wrap) {
              const target = activeThumbEl.offsetLeft - (wrap.clientWidth - activeThumbEl.offsetWidth) / 2;
              wrap.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
            }
          } else {
            /* Desktop : carrousel piloté (translateX) */
            /* Mesure du pas mise en cache (évite un forced reflow à chaque refresh) */
            if (cachedStep === null) {
              const firstThumb = thumbs[0];
              const gapValue = window.getComputedStyle(track).gap || window.getComputedStyle(track).columnGap || '12';
              const gap = parseFloat(gapValue) || 12;
              cachedStep = firstThumb ? firstThumb.getBoundingClientRect().width + gap : 0;
            }
            track.style.transform = `translateX(${-startIndex * cachedStep}px)`;
          }
          if (thumbs.length <= visibleCount()) {
            gallery.classList.add('is-static');
          } else {
            gallery.classList.remove('is-static');
          }
        };

        const goToIndex = (nextIndex, focusActive = true) => {
          if (!thumbs.length) return;
          activeIndex = (nextIndex + thumbs.length) % thumbs.length;
          refresh(focusActive);
        };

        const goStep = (direction) => {
          goToIndex(activeIndex + direction, true);
        };

        thumbs.forEach((thumb, index) => {
          thumb.addEventListener('click', () => {
            goToIndex(index, true);
          });
        });

        if (mainPrev) {
          mainPrev.addEventListener('click', () => goStep(-1));
        }

        if (mainNext) {
          mainNext.addEventListener('click', () => goStep(1));
        }

        mainImage.addEventListener('load', () => {
          mainFrame.classList.remove('is-transitioning');
        });

        if (mainFrame && thumbs.length > 1) {
          mainFrame.addEventListener('touchstart', (event) => {
            touchStartX = event.changedTouches[0] ? event.changedTouches[0].clientX : 0;
            touchStartY = event.changedTouches[0] ? event.changedTouches[0].clientY : 0;
          }, { passive: true });

          mainFrame.addEventListener('touchend', (event) => {
            touchEndX = event.changedTouches[0] ? event.changedTouches[0].clientX : 0;
            touchEndY = event.changedTouches[0] ? event.changedTouches[0].clientY : 0;
            const deltaX = touchEndX - touchStartX;
            const deltaY = touchEndY - touchStartY;
            // Ne déclencher le changement d'image que pour un vrai swipe horizontal,
            // sinon on laisse le scroll vertical de la page passer librement.
            if (Math.abs(deltaX) < 40) return;
            if (Math.abs(deltaX) <= Math.abs(deltaY)) return;
            goStep(deltaX < 0 ? 1 : -1);
          }, { passive: true });
        }

        window.addEventListener('resize', () => { cachedStep = null; refresh(false); });
        refresh(true);

        /* Précharge les images de la galerie quand le navigateur est inactif (après le LCP) */
        /* → clics instantanés sans pénaliser le chargement initial de la page */
        if (thumbs.length > 1) {
          var warmGallery = function() {
            thumbs.forEach(function(thumb) {
              var u = thumb.dataset.src;
              if (u) { var img = new Image(); img.decoding = 'async'; img.src = u; }
            });
          };
          if ('requestIdleCallback' in window) {
            requestIdleCallback(warmGallery, { timeout: 4000 });
          } else {
            window.setTimeout(warmGallery, 2500);
          }
        }
      });

      document
        .querySelectorAll('.jl-formula-shell [data-product-hero]')
        .forEach((hero) => {
          const wrapper = hero.closest('.jl-product-hero-boundary');
          const rightPanel = hero.querySelector('.jl-product-hero__content');

          document.body.style.overflow = '';
          document.documentElement.style.overflow = '';

          if (wrapper) {
            wrapper.style.height = 'auto';
            wrapper.style.minHeight = '0';
            wrapper.style.overflow = 'visible';
          }

          /* .jl-product-hero__media ne doit PAS passer en overflow:visible ici :
             en desktop (≥769px) elle est en position:sticky avec un max-height
             calé sur 100vh et overflow:hidden (cf. product-information-content.liquid,
             règle @media(min-width:769px)) — c'est ce qui empêche les avis Loox,
             plus hauts que la galerie, de déborder visuellement sur la section
             suivante. Ce reset JS écrasait cette protection sur tous les écrans. */

          if (rightPanel) {
            rightPanel.style.height = 'auto';
            rightPanel.style.maxHeight = 'none';
            rightPanel.style.overflow = 'visible';
            rightPanel.style.overflowY = 'visible';
          }
        });

      /* Avis Loox positionnés juste sous la galerie, sans jamais entrer dans
         sa zone position:sticky (jl-produit-da.css) : un élément sticky
         reste épinglé à l'écran pour TOUTE la hauteur de son conteneur, pas
         seulement sa propre hauteur — s'ils vivaient dans le même conteneur
         que la galerie, elle resterait plaquée par-dessus eux tout le temps
         qu'on les fait défiler. Les avis vivent donc hors de ce conteneur,
         positionnés en absolu (cf. CSS) avec des coordonnées calculées ici.

         Important : on mesure .jl-gallery-stick (la galerie elle-même),
         PAS .jl-product-hero__media — cette dernière est étirée
         (align-self:stretch, jl-produit-da.css) à la hauteur de la colonne
         de droite, donc bien plus grande que la galerie réelle. Et on lit
         offsetTop/offsetHeight plutôt que getBoundingClientRect : cette
         dernière reflète la position ÉCRAN actuelle, faussée si la galerie
         est en cours d'épinglage au moment du calcul (ex. recalcul après un
         redimensionnement pendant qu'on a déjà scrollé) — offsetTop reste
         toujours celui du flux normal, peu importe l'état d'épinglage. */
      document
        .querySelectorAll('.jl-formula-shell [data-product-hero]')
        .forEach((hero) => {
          const media = hero.querySelector('.jl-product-hero__media');
          const galleryWrap = hero.querySelector('.jl-gallery-wrap');
          const loox = hero.querySelector('[data-loox-under-media]');
          if (!media || !galleryWrap || !loox) return;

          const positionLooxUnderMedia = () => {
            if (window.innerWidth < 769) {
              loox.style.position = '';
              loox.style.top = '';
              loox.style.left = '';
              loox.style.width = '';
              return;
            }
            /* getBoundingClientRect sur .jl-gallery-wrap (le contenu réel de
               la galerie : image, vignettes, pastilles "Ce qu'il y gagne"),
               PAS sur .media ni .jl-gallery-stick — offsetTop/offsetHeight
               s'avèrent peu fiables ici à cause du sticky d'un ancêtre.
               getBoundingClientRect donne la position ÉCRAN actuelle ; comme
               .jl-product-hero (repère de loox) est mesuré au même instant,
               leur différence reste juste peu importe le défilement. */
            const heroRect = hero.getBoundingClientRect();
            const galleryRect = galleryWrap.getBoundingClientRect();
            const mediaRect = media.getBoundingClientRect();
            loox.style.top = (galleryRect.bottom - heroRect.top) + 'px';
            loox.style.left = (mediaRect.left - heroRect.left) + 'px';
            loox.style.width = mediaRect.width + 'px';
          };

          /* .jl-product-hero__media doit occuper, dans le flux normal, la
             hauteur galerie + avis — pas juste la galerie — sinon rien ne
             pousse "LE SAVIEZ-VOUS" (la section suivante) de la bonne
             quantité : soit elle colle trop tôt (chevauchement), soit un
             calcul figé laisse un vide disproportionné. On pose donc un
             min-height DIRECTEMENT sur .media (jamais un enfant en plus :
             ajouté comme second enfant, un tel espaceur perturbait le
             flex-column existant de cette colonne — prévue à l'origine
             pour empiler galerie → quiz diagnostic, cf. jl-formula.css —
             et décalait toute la galerie vers le bas). */
          const syncMediaMinHeight = () => {
            if (window.innerWidth < 769) {
              media.style.minHeight = '';
              return;
            }
            const mediaRect = media.getBoundingClientRect();
            const galleryRect = galleryWrap.getBoundingClientRect();
            const desired = (galleryRect.bottom - mediaRect.top) + loox.offsetHeight;
            media.style.minHeight = Math.max(0, desired) + 'px';
          };

          const refresh = () => {
            positionLooxUnderMedia();
            syncMediaMinHeight();
          };

          refresh();
          /* Un seul appel synchrone au chargement du script ne suffit pas :
             la police web des pastilles "Ce qu'il y gagne" peut finir de
             charger après coup (FOUT) et changer leur hauteur (retour à la
             ligne différent), décalant où la galerie se termine vraiment.
             Un double requestAnimationFrame laisse le temps à au moins un
             cycle de mise en page de se terminer avant de re-mesurer — plus
             fiable que l'événement 'load', qui peut déjà être passé si ce
             script s'exécute tard (defer / fin de page). */
          requestAnimationFrame(() => requestAnimationFrame(refresh));
          window.addEventListener('resize', refresh);
          window.addEventListener('load', refresh);

          if ('ResizeObserver' in window) {
            new ResizeObserver(syncMediaMinHeight).observe(loox);
          }
          /* Filet de sécurité, même avec ResizeObserver : Loox charge ses
             avis de façon asynchrone, parfois plusieurs secondes après le
             chargement de la page, et le moment exact n'est pas garanti. On
             recalcule à intervalles réguliers pendant 20 s pour couvrir ce
             chargement quelle que soit sa vitesse, sans dépendre d'un seul
             mécanisme de notification. Repositionner (pas seulement
             resynchroniser la hauteur) tant qu'on est encore tout en haut de
             la page : au-delà, la galerie peut être épinglée (sticky) et sa
             position mesurée à l'écran ne refléterait plus sa position
             normale dans la page. */
          let pollCount = 0;
          const pollId = setInterval(() => {
            if (window.scrollY < 50) positionLooxUnderMedia();
            syncMediaMinHeight();
            pollCount += 1;
            if (pollCount > 20) clearInterval(pollId);
          }, 1000);
        });

      document.querySelectorAll('.jl-formula__pricing').forEach((pricing) => {
        const cards = Array.from(pricing.querySelectorAll('[data-offer-card]'));
        const scope = pricing.closest('.jl-inline-section--purchase');
        const quantityInput = scope ? scope.querySelector('[data-offer-quantity-input]') : null;
        const labelInput = scope ? scope.querySelector('[data-offer-label-input]') : null;
        const giftBlock = scope ? scope.querySelector('[data-gift-block]') : null;
        const shippingRow = giftBlock ? giftBlock.querySelector('[data-gift-row="shipping"]') : null;
        const shippingText = giftBlock ? giftBlock.querySelector('[data-gift-shipping-text]') : null;
        const shippingEmoji = giftBlock ? giftBlock.querySelector('[data-gift-shipping-emoji]') : null;
        const shippingBadge = giftBlock ? giftBlock.querySelector('[data-gift-shipping-badge]') : null;
        if (!cards.length || !quantityInput || !labelInput) return;

        const updateGiftState = (_offerValue) => {
          /* Blocs cadeaux supprimés — no-op */
        };

        /* L'étape "Dis-nous qui c'est" (prénom/poids) reste masquée tant que
           le client n'a pas interagi avec le choix de formule : on ne veut
           pas lui demander ces infos avant même qu'il ait décidé comment il
           achète. Appelée uniquement depuis les listeners de clic ci-dessous
           — jamais depuis updateSelection() elle-même, qui tourne aussi une
           fois au chargement de la page pour poser l'état initial. */
        const identityStep = scope ? scope.querySelector('[data-identity-step]') : null;
        const revealIdentity = () => { if (identityStep) identityStep.hidden = false; };

        const updateSelection = (nextCard) => {
          cards.forEach((card) => {
            const selected = card === nextCard;
            card.classList.toggle('is-selected', selected);
            card.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          /* Si un poids a déjà été choisi (Grand = 2 sachets), sa quantité prime sur la
             valeur statique de la carte, sinon un simple re-clic sur la carte "Abonnement"
             écrase silencieusement le "2 sachets" du poids Grand avec le "1" par défaut. */
          const activeWeightBtnForQty = scope ? scope.querySelector('.jl-ws-btn.is-active') : null;
          const activeSachets = activeWeightBtnForQty ? parseInt(activeWeightBtnForQty.dataset.wsSachets, 10) : null;
          if (nextCard.dataset.offerValue === 'abonnement' && activeSachets) {
            quantityInput.value = activeSachets;
          } else if (nextCard.dataset.offerValue === 'achat-unique') {
            /* Respecte la quantité choisie via le steppeur +/- de l'achat unique. */
            quantityInput.value = nextCard.dataset.oneshotQty || nextCard.dataset.offerQuantity || '1';
          } else {
            quantityInput.value = nextCard.dataset.offerQuantity || '1';
          }
          labelInput.value = nextCard.dataset.offerValue === 'achat-unique' ? 'Achat unique' : 'Abonnement';
          updateGiftState(nextCard.dataset.offerValue || 'abonnement');
          const form = scope ? scope.querySelector('.jl-formula__notify-form') : null;
          const sellingPlanInput = scope ? scope.querySelector('[data-selling-plan-input]') : null;
          if (sellingPlanInput && form) {
            /* Préférer le plan du poids sélectionné, sinon le plan par défaut */
            const activeWeightBtn = scope ? scope.querySelector('.jl-ws-btn.is-active') : null;
            const planId = (activeWeightBtn && activeWeightBtn.dataset.wsPlan) || form.dataset.aboPlanId || '';
            if (nextCard.dataset.offerValue === 'abonnement') {
              sellingPlanInput.value = planId;
              sellingPlanInput.disabled = false;
            } else {
              sellingPlanInput.value = '';
              sellingPlanInput.disabled = true;
            }
          }
          /* Radio dots */
          const radioAbo      = scope ? scope.querySelector('[data-radio-abo]') : null;
          const radioOneshot  = scope ? scope.querySelector('[data-radio-oneshot]') : null;
          const isAbo = nextCard.dataset.offerValue === 'abonnement';
          if (radioAbo)     radioAbo.classList.toggle('is-checked', isAbo);
          if (radioOneshot) radioOneshot.classList.toggle('is-checked', !isAbo);

          /* Bouton(s) panier : texte adapté (peut y en avoir 2 : proche du prix + en bas) */
          const submitBtns = scope ? scope.querySelectorAll('.jl-formula__submit') : [];
          submitBtns.forEach((btn) => {
            btn.textContent = isAbo ? 'S\'abonner · Ajouter au panier' : 'Ajouter au panier · Achat unique';
          });

          /* Afficher/masquer le plan livraison selon le mode sélectionné */
          const ws = scope ? scope.querySelector('[data-weight-selector]') : null;
          const wsKey = ws ? 'jl_ws_' + ws.id : null;
          const deliveryBox = scope ? scope.querySelector('[data-abo-delivery]') : null;
          if (isAbo) {
            /* Ré-afficher si un poids avait déjà été sélectionné */
            if (wsKey && window[wsKey]) window[wsKey].showDelivery();
          } else {
            /* Masquer le plan livraison pour l'achat unique */
            if (deliveryBox) deliveryBox.hidden = true;
          }
        };

        cards.forEach((card) => {
          card.addEventListener('click', () => { revealIdentity(); updateSelection(card); });
          card.addEventListener('keydown', (event) => {
            /* Ce raccourci clavier (Entrée/Espace active la carte, comme un
               bouton) ne doit réagir que si c'est la carte elle-même qui a le
               focus. Sans ce garde-fou, taper un espace dans un champ imbriqué
               (prénom du chien, dans .jl-abo-card qui EST une data-offer-card)
               remontait jusqu'ici : preventDefault() sur la touche Espace
               empêchait le caractère d'être saisi, coupant tout prénom composé
               ("Jean Marc" devenait "Jeanmarc"). */
            if (event.target !== card) return;
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            revealIdentity();
            updateSelection(card);
          });
        });

        /* Le bouton d'achat rapide vit à l'intérieur de la carte abonnement
           (jl-abo-card) pour rester proche du prix. Sans stopPropagation, son
           clic remonte jusqu'au clic de la carte, qui rejoue updateSelection()
           et écrase la quantité (remise à data-offer-quantity="1" statique) —
           annulant silencieusement le "2 sachets" du poids "grand" choisi juste
           avant. Ces boutons ne doivent jamais re-déclencher la sélection de carte. */
        if (scope) {
          scope.querySelectorAll('.jl-formula__submit').forEach((btn) => {
            btn.addEventListener('click', (event) => event.stopPropagation());
          });
        }

        updateSelection(cards.find((card) => card.classList.contains('is-selected')) || cards[0]);
      });

      /* ── Steppeur quantité de l'achat unique (+/-) ── */
      document.querySelectorAll('[data-oneshot-stepper]').forEach((stepper) => {
        const card = stepper.closest('[data-offer-value="achat-unique"]');
        const scope = stepper.closest('.jl-inline-section--purchase');
        if (!card || !scope) return;

        const valueEl = stepper.querySelector('[data-oneshot-qty-value]');
        const priceEl = scope.querySelector('[data-oneshot-price]');
        const quantityInput = scope.querySelector('[data-offer-quantity-input]');
        const unitCents = parseInt((priceEl && priceEl.dataset.oneshotUnitCents) || '0', 10);
        const MAX_QTY = 20;

        function fmtEur(cents) {
          return (cents / 100).toFixed(2).replace('.', ',') + ' €';
        }

        function render(qty) {
          card.dataset.oneshotQty = qty;
          if (valueEl) valueEl.textContent = qty;
          if (priceEl && unitCents) priceEl.textContent = fmtEur(unitCents * qty);
          /* Si l'achat unique est déjà l'offre sélectionnée, répercuter tout de
             suite sur le formulaire — sinon updateSelection() le fera au clic. */
          if (quantityInput && card.classList.contains('is-selected')) {
            quantityInput.value = qty;
          }
        }

        stepper.querySelectorAll('[data-oneshot-qty-decrease], [data-oneshot-qty-increase]').forEach((btn) => {
          btn.addEventListener('click', (event) => {
            /* Ne PAS stopPropagation : le clic doit aussi remonter jusqu'à la
               carte pour la sélectionner comme offre active (updateSelection),
               qui relira card.dataset.oneshotQty déjà mis à jour ci-dessous. */
            const current = parseInt(card.dataset.oneshotQty, 10) || 1;
            const isIncrease = event.currentTarget.hasAttribute('data-oneshot-qty-increase');
            const next = Math.max(1, Math.min(MAX_QTY, current + (isIncrease ? 1 : -1)));
            render(next);
          });
        });
      });

      document.querySelectorAll('[data-scroll-indicator]').forEach((scroller) => {
        const wrapper = scroller.closest('[data-scroll-indicator-wrap]');
        if (!wrapper) return;

        const hideIndicator = () => {
          if (scroller.scrollLeft > 6) {
            wrapper.classList.add('is-scrolled');
          }
        };

        scroller.addEventListener('scroll', hideIndicator, { passive: true });
        hideIndicator();
      });

      const initFormulaFaq = () => {
        document.querySelectorAll('.jl-faq').forEach((faq) => {
          if (faq.dataset.faqInitialized === 'true') return;
          faq.dataset.faqInitialized = 'true';

          const items = Array.from(faq.querySelectorAll('.jl-faq-item'));
          items.forEach((item) => {
            const trigger = item.querySelector('.jl-faq-trigger');
            const panel = item.querySelector('.jl-faq-panel');
            if (!trigger || !panel) return;

            trigger.addEventListener('click', () => {
              const isOpen = item.classList.contains('is-open');
              items.forEach((otherItem) => {
                const otherTrigger = otherItem.querySelector('.jl-faq-trigger');
                const otherPanel = otherItem.querySelector('.jl-faq-panel');
                if (!otherTrigger || !otherPanel) return;
                otherItem.classList.remove('is-open');
                otherTrigger.setAttribute('aria-expanded', 'false');
                otherPanel.style.maxHeight = null;
              });

              if (isOpen) return;

              item.classList.add('is-open');
              trigger.setAttribute('aria-expanded', 'true');
              panel.style.maxHeight = `${panel.scrollHeight}px`;
            });
          });

          const openItem = items.find((item) => item.classList.contains('is-open'));
          const openPanel = openItem ? openItem.querySelector('.jl-faq-panel') : null;
          if (openPanel) openPanel.style.maxHeight = `${openPanel.scrollHeight}px`;
        });
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFormulaFaq, { once: true });
      } else {
        initFormulaFaq();
      }
    })();

    (() => {
      document.querySelectorAll('.jl-ingredient-toggle').forEach((btn) => {
        btn.addEventListener('click', () => {
          const list = btn.previousElementSibling;
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          const hiddenCount = btn.dataset.hiddenCount;
          if (expanded) {
            list.classList.add('jl-ingredient-list--collapsed');
            btn.setAttribute('aria-expanded', 'false');
            btn.querySelector('.jl-ingredient-toggle__label').textContent = 'Voir les ' + hiddenCount + ' autres actifs';
            list.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          } else {
            list.classList.remove('jl-ingredient-list--collapsed');
            btn.setAttribute('aria-expanded', 'true');
            btn.querySelector('.jl-ingredient-toggle__label').textContent = 'Replier la liste';
          }
        });
      });

      /* ── Sélecteur poids (v2 — prix dynamiques, 2× grand chien) ── */
      document.querySelectorAll('[data-weight-selector]').forEach(function(ws) {
        const buttons      = ws.querySelectorAll('.jl-ws-btn');
        const purchaseZone = ws.closest('.jl-inline-section--purchase');
        const aboCard      = purchaseZone ? purchaseZone.querySelector('[data-offer-value="abonnement"]') : null;
        const deliveryBox  = aboCard ? aboCard.querySelector('[data-abo-delivery]') : null;
        const deliveryMain = deliveryBox ? deliveryBox.querySelector('[data-abo-delivery-main]') : null;
        const deliveryDate = deliveryBox ? deliveryBox.querySelector('[data-abo-delivery-date]') : null;
        const priceOldEl   = aboCard ? aboCard.querySelector('[data-abo-price-old]') : null;
        const priceNewEl   = aboCard ? aboCard.querySelector('[data-abo-price-new]') : null;
        const perDayEl     = aboCard ? aboCard.querySelector('[data-abo-per-day]') : null;
        const savingEl     = aboCard ? aboCard.querySelector('[data-abo-saving]') : null;
        const aboCents     = parseInt(ws.dataset.aboCents, 10) || 3120; /* prix abo 1 sachet en centimes */
        const oneCents     = parseInt(ws.dataset.oneCents, 10) || 3670;

        /* Switcher le selling plan Shopify selon le poids sélectionné (chaque bouton porte son plan) */
        function updateSellingPlan(planId) {
          var planInput = purchaseZone ? purchaseZone.querySelector('[data-selling-plan-input]') : null;
          if (planInput && planId) planInput.value = planId;
        }

        /* Prix par jour selon poids (aboCents × sachets / days) */
        function fmtEur(cents) {
          var v = cents / 100;
          return v.toFixed(2).replace('.', ',') + ' €';
        }
        function fmtDate(days) {
          var d = new Date();
          d.setDate(d.getDate() + days);
          return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
        }

        /* Stocker la sélection active pour que updateDeliveryVisibility() puisse l'utiliser */
        var activeTier = null;

        window['jl_ws_' + ws.id] = {
          showDelivery: function() {
            if (!activeTier || !deliveryBox) return;
            var sachets = activeTier.sachets;
            var days    = activeTier.days;
            var sl      = sachets > 1 ? 'sachets' : 'sachet';
            if (deliveryMain) deliveryMain.textContent =
              sachets + ' ' + sl + ' · livraison tous les ' + days + ' jours';
            if (deliveryDate) deliveryDate.textContent =
              'Première livraison expédiée sous 48h · renouvelée le ' + fmtDate(days);
            deliveryBox.hidden = false;
          },
          hideDelivery: function() {
            if (deliveryBox) deliveryBox.hidden = true;
          }
        };

        buttons.forEach(function(btn) {
          /* Stopper la propagation pour ne pas déclencher le clic sur la carte parente */
          btn.addEventListener('click', function(e) {
            e.stopPropagation();
            buttons.forEach(function(b) { b.classList.remove('is-active'); });
            btn.classList.add('is-active');
            /* Cacher le message d'erreur si affiché */
            var errEl = ws.parentNode ? ws.parentNode.querySelector('.jl-weight-error') : null;
            if (errEl) errEl.hidden = true;

            var sachets  = parseInt(btn.dataset.wsSachets, 10);
            var days     = parseInt(btn.dataset.wsDays, 10);
            var duration = btn.dataset.wsDuration;
            var sl       = sachets > 1 ? 'sachets' : 'sachet';
            activeTier   = { sachets: sachets, days: days, duration: duration };

            /* Calcul des prix selon nombre de sachets */
            var totalAboCents = aboCents * sachets;
            var totalOneCents = oneCents * sachets;
            var savedCents    = totalOneCents - totalAboCents;
            var perDayCents   = Math.round(totalAboCents / days);

            if (priceOldEl) priceOldEl.textContent = fmtEur(totalOneCents);
            if (priceNewEl) priceNewEl.textContent = fmtEur(totalAboCents);
            if (savingEl)   savingEl.textContent   = 'Économisez ' + fmtEur(savedCents);
            if (perDayEl)   perDayEl.textContent   = 'Soit ' + fmtEur(perDayCents) + ' par jour';

            /* Afficher le plan livraison */
            if (deliveryMain) deliveryMain.textContent =
              sachets + ' ' + sl + ' · livraison tous les ' + days + ' jours';
            if (deliveryDate) deliveryDate.textContent =
              'Première livraison expédiée sous 48h · renouvelée le ' + fmtDate(days);

            /* Switcher le selling plan Shopify selon le poids */
            updateSellingPlan(btn.dataset.wsPlan);

            /* Enregistrer le poids choisi comme propriété de ligne (repris/pré-rempli au panier) */
            var weightProp = purchaseZone ? purchaseZone.querySelector('[data-weight-property-input]') : null;
            if (weightProp) {
              var rangeEl = btn.querySelector('.jl-ws-btn__range');
              var sizeEl  = btn.querySelector('.jl-ws-btn__size');
              if (rangeEl && sizeEl) {
                weightProp.value = rangeEl.textContent.trim() + ' (' + sizeEl.textContent.trim() + ')';
              }
            }

            /* Propriété poids_chien : valeur fermée Petit/Moyen/Grand (matching n8n/Klaviyo) */
            var poidsChienProp = purchaseZone ? purchaseZone.querySelector('[data-poids-chien-input]') : null;
            if (poidsChienProp) poidsChienProp.value = tierToPoidsChien(btn.dataset.wsTier);

            /* Afficher seulement si abonnement est actif */
            var currentOffer = purchaseZone ? purchaseZone.querySelector('[data-offer-card].is-selected') : null;
            if (deliveryBox) {
              deliveryBox.hidden = !currentOffer || currentOffer.dataset.offerValue !== 'abonnement';
            }

            /* Mettre à jour la quantité selon le nombre de sachets (Grand = 2) —
               UNIQUEMENT si l'abonnement est l'offre active. Ce handler tournait
               avant sans condition et écrasait silencieusement la quantité choisie
               au steppeur +/- de l'achat unique (ex : 6 sachets repassait à 1 dès
               qu'on cliquait un poids), sans que l'affichage du steppeur ne s'en
               rende compte — écart invisible entre ce qui est montré et ce qui
               part réellement au panier. */
            var qtyInput = purchaseZone ? purchaseZone.querySelector('[data-offer-quantity-input]') : null;
            if (qtyInput && currentOffer && currentOffer.dataset.offerValue === 'abonnement') {
              qtyInput.value = sachets;
            }
          });
        });

        /* AUCUNE pré-sélection de poids, jamais : la page arrive vierge et le
           client doit choisir consciemment avant de pouvoir ajouter au panier
           (la validation au submit bloque et guide vers le sélecteur). */
      });

      /* ── Validation poids + prénom(s) du/des chien(s) : message erreur ── */
      document.querySelectorAll('.jl-formula__notify-form').forEach(function(form) {
        form.addEventListener('submit', function(e) {
          var scope = form.closest('.jl-inline-section--purchase');
          if (!scope) return;

          var ws = scope.querySelector('[data-weight-selector]');
          var activeBtn = ws ? ws.querySelector('.jl-ws-btn.is-active') : null;
          var errEl = ws ? ws.parentNode.querySelector('.jl-weight-error') : null;
          var errTextEl = errEl ? errEl.querySelector('[data-weight-error-text]') : null;
          var dog1NameInput = scope.querySelector('[data-dog1-name-input]');
          var dog1Name = dog1NameInput ? dog1NameInput.value.trim() : '';

          var dog2Panel = scope.querySelector('[data-dog2-panel]');
          var dog2Active = dog2Panel && !dog2Panel.hidden;
          var dog2NameInput = scope.querySelector('[data-dog2-name-input]');
          var dog2Name = dog2NameInput ? dog2NameInput.value.trim() : '';
          var dog2WeightBtn = dog2Panel ? dog2Panel.querySelector('.jl-dog2-btn.is-active') : null;

          var fail = null;
          if (!dog1Name) {
            fail = 'Indiquez le prénom de votre chien pour continuer.';
          } else if (!activeBtn) {
            fail = 'Sélectionnez le poids de votre chien pour continuer.';
          } else if (dog2Active && !dog2Name) {
            fail = 'Indiquez le prénom de votre 2ème chien pour continuer.';
          } else if (dog2Active && !dog2WeightBtn) {
            fail = 'Sélectionnez le poids de votre 2ème chien pour continuer.';
          }

          if (fail) {
            e.preventDefault();
            /* Si le client n'a jamais interagi avec le choix de formule
               (abonnement pré-sélectionné par défaut), l'étape "Dis-nous qui
               c'est" est encore masquée : sans ça, le message d'erreur
               pointerait vers un champ invisible. */
            var identityStep = scope.querySelector('[data-identity-step]');
            if (identityStep) identityStep.hidden = false;
            if (errEl) {
              if (errTextEl) errTextEl.textContent = fail;
              errEl.hidden = false;
              /* Shake du sélecteur */
              if (ws) {
                ws.style.animation = 'none';
                ws.offsetHeight; /* reflow */
                ws.style.animation = 'jl-shake 0.4s ease';
                ws.addEventListener('animationend', function() { ws.style.animation = ''; }, { once: true });
              }
              errEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          } else {
            if (errEl) errEl.hidden = true;
          }
        });
      });

      /* Cacher le message d'erreur dès que le client renseigne un prénom */
      document.querySelectorAll('[data-dog1-name-input], [data-dog2-name-input]').forEach(function(input) {
        input.addEventListener('input', function() {
          var scope = input.closest('.jl-inline-section--purchase');
          var errEl = scope ? scope.querySelector('.jl-weight-error') : null;
          if (errEl) errEl.hidden = true;
        });
      });

      /* ── Achat unique replié en lien : ne devient un encadré qu'au clic ── */
      document.querySelectorAll('[data-oneshot-reveal]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var card = link.nextElementSibling;
          if (!card) return;
          link.hidden = true;
          card.hidden = false;
          /* Réutilise le listener déjà posé sur la carte (updateSelection) au
             lieu de dupliquer sa logique de sélection d'offre. */
          card.click();
          card.focus();
        });
      });

    })();


/* ── Barre d'achat mobile collante ── */
(() => {
  const bar = document.querySelector('[data-mobile-buybar]');
  if (!bar) return;
  const purchase = document.querySelector('.jl-inline-section--purchase');
  if (!purchase) return;
  const priceEl = bar.querySelector('[data-buybar-price]');
  const metaEl = bar.querySelector('[data-buybar-meta]');

  /* Prix affiché = celui de l'offre sélectionnée (abo ou achat unique) */
  const syncPrice = () => {
    const aboSelected = !!purchase.querySelector('.jl-abo-card.is-selected');
    const src = aboSelected
      ? purchase.querySelector('[data-abo-price-new]')
      : purchase.querySelector('[data-oneshot-price]');
    if (src && priceEl) priceEl.textContent = src.textContent.trim();
    if (metaEl) metaEl.textContent = aboSelected ? '-15% · livraison offerte' : 'Achat unique';
  };
  purchase.addEventListener('click', () => window.setTimeout(syncPrice, 80));
  syncPrice();

  /* Visible dès que la zone d'achat n'est pas à l'écran (avant OU après) :
     le client peut acheter pendant qu'il regarde la galerie ou les avis. */
  let ticking = false;
  const update = () => {
    ticking = false;
    const r = purchase.getBoundingClientRect();
    const onScreen = r.bottom > 0 && r.top < window.innerHeight;
    bar.hidden = onScreen;
  };
  window.addEventListener('scroll', () => {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }, { passive: true });
  update();
})();

/* ── Tiroir panier après ajout (fetch /cart/add.js + /cart?section_id=main-cart) ── */
(function () {
  var drawer = document.getElementById('jl-cart-drawer');
  if (!drawer) return;
  var body = document.getElementById('jl-cart-drawer-body');

  function closeDrawer() { if (drawer.open) drawer.close(); }
  drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });
  /* Clic sur le fond (backdrop natif du <dialog>) : ferme aussi */
  drawer.addEventListener('click', function (e) {
    if (e.target === drawer) closeDrawer();
  });

  var footer = document.getElementById('jl-cart-drawer-footer');

  function showLoading() {
    body.innerHTML = '<div class="jl-cart-drawer__loading">Ajout en cours…</div>';
    if (footer) footer.innerHTML = '';
  }
  function showError() {
    body.innerHTML = '<div class="jl-cart-drawer__loading">Un problème est survenu. <a href="/cart">Voir mon panier</a></div>';
    if (footer) footer.innerHTML = '';
  }
  /* IMPORTANT : injecter le wrapper de section entier
     (#shopify-section-main-cart), pas seulement son contenu.
     Deux couches cassaient silencieusement le recalcul natif du total au
     clic +/- ("le total reste stoïque") :
     1) <cart-items-component> est le composant qui écoute les changements de
        quantité — extraire uniquement .cart-page__items/.cart-page__summary
        l'excluait du DOM injecté, donc plus aucun listener ne tournait.
     2) Même en réintégrant <cart-items-component>, le recalcul appelle
        ensuite morphSection('main-cart', ...), qui cherche
        #shopify-section-main-cart pour appliquer la mise à jour — sans ce
        wrapper (auto-généré par Shopify autour de chaque section), l'appel
        échoue silencieusement (promesse rejetée, avalée par le .catch()).
     Le résumé/bouton PAYER reste visuellement fixe en bas via CSS
     (position: sticky), pas via une sortie du DOM. */
  function renderCartFragment(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var sectionWrapper = doc.getElementById('shopify-section-main-cart');
    body.innerHTML = '';
    if (footer) footer.innerHTML = '';
    if (sectionWrapper) {
      body.appendChild(sectionWrapper);
    } else {
      showError();
    }
  }
  function refreshDrawer() {
    return fetch('/cart?section_id=main-cart')
      .then(function (r) { return r.text(); })
      .then(renderCartFragment);
  }

  /* Suppression d'une ligne : le fragment injecté n'a pas le composant JS de
     la page panier, on gère le clic nous-mêmes via l'API cart/change */
  drawer.addEventListener('click', function (event) {
    var removeBtn = event.target.closest('.jl-cart-remove, .cart-items__remove');
    if (!removeBtn) return;
    event.preventDefault();
    var onClick = removeBtn.getAttribute('on:click') || '';
    var lineMatch = onClick.match(/onLineItemRemove\/(\d+)/);
    var row = removeBtn.closest('.cart-items__table-row');
    var editLink = row ? row.querySelector('[data-jl-cart-edit-link]') : null;
    var lineKey = editLink ? editLink.getAttribute('data-line-key') : null;
    var payload = lineKey ? { id: lineKey, quantity: 0 } : (lineMatch ? { line: parseInt(lineMatch[1], 10), quantity: 0 } : null);
    if (!payload) return;
    removeBtn.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function () { return refreshDrawer(); })
      .catch(function () { removeBtn.disabled = false; });
  });

  /* ── Logique 2ème chien ── */
  document.querySelectorAll('[data-dog2-zone]').forEach(function (zone) {
    var toggleBtn = zone.querySelector('[data-dog2-toggle]');
    var panel     = zone.querySelector('[data-dog2-panel]');
    var removeBtn = zone.querySelector('[data-dog2-remove]');
    var dog2Btns  = zone.querySelectorAll('.jl-dog2-btn');

    if (toggleBtn && panel) {
      toggleBtn.addEventListener('click', function () {
        panel.hidden = false;
        toggleBtn.hidden = true;
      });
    }
    if (removeBtn && panel) {
      removeBtn.addEventListener('click', function () {
        panel.hidden = true;
        toggleBtn.hidden = false;
        dog2Btns.forEach(function (b) { b.classList.remove('is-active'); });
      });
    }
    dog2Btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        dog2Btns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('.jl-formula__notify-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      /* Si le poids n'est pas sélectionné, l'autre listener (validation) a déjà
         appelé preventDefault() et affiché son message : on ne fait rien de plus. */
      if (e.defaultPrevented) return;
      e.preventDefault();
      showLoading();
      drawer.showModal();

      /* Vérifier si un 2ème chien est sélectionné */
      var purchaseZone = form.closest('.jl-formula');
      var scope     = form.closest('.jl-inline-section--purchase');
      var dog2Zone  = purchaseZone ? purchaseZone.querySelector('[data-dog2-zone]') : null;
      var dog2Panel = dog2Zone ? dog2Zone.querySelector('[data-dog2-panel]') : null;
      var dog2Btn   = dog2Panel && !dog2Panel.hidden
        ? dog2Panel.querySelector('.jl-dog2-btn.is-active')
        : null;
      var dog2NameInput = dog2Panel ? dog2Panel.querySelector('[data-dog2-name-input]') : null;

      /* Recopier le prénom du chien 1 (champ visible) dans la propriété de ligne cachée */
      var dog1NameInput  = scope ? scope.querySelector('[data-dog1-name-input]') : null;
      var prenomChienProp = form.querySelector('[data-prenom-chien-input]');
      if (prenomChienProp) prenomChienProp.value = dog1NameInput ? dog1NameInput.value.trim() : '';

      /* IMPORTANT : envoyer un FormData brut sérialise en multipart/form-data,
         et Shopify perd alors silencieusement selling_plan (et parfois la
         quantité) — déjà constaté ailleurs sur ce projet. On repasse en
         application/x-www-form-urlencoded, qui fonctionne de façon fiable. */
      var mainBody = new URLSearchParams(new FormData(form)).toString();

      var addDog1 = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: mainBody
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
      });

      var addDog2 = dog2Btn ? (function () {
        var variantInput = form.querySelector('[data-variant-id-input]');
        var variantId    = variantInput ? variantInput.value : '';
        var sachets2     = parseInt(dog2Btn.dataset.wsSachets, 10) || 1;
        var plan2        = dog2Btn.dataset.wsPlan || '';
        var params2      = new URLSearchParams({
          id:           variantId,
          quantity:     sachets2,
          selling_plan: plan2,
          'properties[Offre]':          'Abonnement',
          'properties[Poids du chien]': (dog2Btn.querySelector('.jl-ws-btn__range') || {}).textContent || '',
          'properties[prenom_chien]':   dog2NameInput ? dog2NameInput.value.trim() : '',
          'properties[poids_chien]':    tierToPoidsChien(dog2Btn.dataset.wsTier)
        }).toString();
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: params2
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
        });
      })() : Promise.resolve();

      Promise.all([addDog1, addDog2])
        .then(function () { return fetch('/cart?section_id=main-cart'); })
        .then(function (r) { return r.text(); })
        .then(renderCartFragment)
        .catch(function (err) {
          console.warn('Ajout panier : erreur', err);
          showError();
        });
    });
  });

  /* "Modifier" (ligne abonnement) : retire la ligne existante avant de renvoyer
     vers la page produit — pré-remplie (prénom + poids passés dans l'URL) pour
     que le client ajuste sa sélection au lieu de tout recommencer. Délégation
     d'événement car le fragment du tiroir est réinjecté dynamiquement. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-jl-cart-edit-link]');
    if (!link) return;
    var lineKey = link.getAttribute('data-line-key');
    if (!lineKey) return;

    event.preventDefault();
    var url = new URL(link.getAttribute('href'), window.location.origin);
    var prefillName = link.getAttribute('data-prefill-name');
    var prefillWeight = link.getAttribute('data-prefill-weight');
    if (prefillName) url.searchParams.set('jl_name', prefillName);
    if (prefillWeight) url.searchParams.set('jl_weight', prefillWeight);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).then(function () {
      window.location.href = url.toString();
    }).catch(function () {
      window.location.href = url.toString();
    });
  });
})();

/* ── Pré-remplissage depuis "Modifier" du panier (?jl_name=...&jl_weight=...) :
   restaure le prénom du chien et re-sélectionne le bon bouton de poids.
   Prioritaire sur le préremplissage "client connecté" ci-dessous : venir d'un
   clic explicite sur "Modifier" doit toujours l'emporter sur la valeur par
   défaut du compte (donc pas de garde !input.value ici — on écrase). ── */
function jlWeightTierFromLabel(weight) {
  var w = (weight || '').toLowerCase();
  if (w.indexOf('grand') !== -1 || w.indexOf('30 kg et plus') !== -1) return 'grand';
  if (w.indexOf('moyen') !== -1 || w.indexOf('11') !== -1) return 'moyen';
  if (w.indexOf('petit') !== -1 || w.indexOf('1 ') === 0 || w.indexOf('10 kg') !== -1) return 'petit';
  return null;
}
function jlSelectWeightTier(tier) {
  var btn = document.querySelector('.jl-ws-btn[data-ws-tier="' + tier + '"]:not(.jl-dog2-btn)');
  if (btn && !btn.classList.contains('is-active')) btn.click();
}
(function () {
  var params = new URLSearchParams(window.location.search);
  var name = params.get('jl_name');
  var weight = params.get('jl_weight');
  if (!name && !weight) return;

  if (name) {
    /* Le champ visible (.jl-dogname__input) est distinct du champ caché
       properties[prenom_chien] synchronisé par JS : remplir les deux */
    ['.jl-dogname__input', 'input[name="properties[prenom_chien]"]'].forEach(function (sel) {
      var input = document.querySelector(sel);
      if (input) {
        input.value = name;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  if (weight) {
    var tier = jlWeightTierFromLabel(weight);
    if (tier) jlSelectWeightTier(tier);
  }
})();

/* ── Client connecté : le prénom est déjà posé en dur par Liquid
   (data-dog1-name-input value="..."), reste à sélectionner le bon poids —
   seulement si "Modifier" (ci-dessus) n'a pas déjà tranché. ── */
(function () {
  var params = new URLSearchParams(window.location.search);
  if (params.get('jl_name') || params.get('jl_weight')) return;

  var input = document.querySelector('[data-dog1-name-input]');
  if (!input || !input.value) return;

  var weightAttr = input.getAttribute('data-customer-weight');
  var tier = weightAttr ? jlWeightTierFromLabel(weightAttr) : null;
  if (tier) jlSelectWeightTier(tier);

  /* Donnée pré-remplie depuis le compte client : on ouvre quand même l'étape
     "Dis-nous qui c'est" pour que le client VOIE et puisse vérifier/corriger
     avant d'ajouter au panier lui-même. Sans ça, l'étape restait masquée (elle
     ne se révèle normalement qu'au clic sur une offre) et un client déjà
     identifié pouvait valider sa commande sans jamais voir les infos
     pré-remplies pour son chien — jamais d'ajout avec une donnée invisible
     à l'écran. */
  var identityStep = document.querySelector('[data-identity-step]');
  if (identityStep) identityStep.hidden = false;
})();
